import { useParams } from "react-router-dom";

import CompaniesDetail from "./Detail";
import CompaniesList from "./List.jsx";
import LoggerBtn from "../../LoggerBtn";
import UploadSortBtn from "../../UploadSortBtn/index.jsx";

const CompaniesPage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? CompaniesDetail : CompaniesList;

    return (
        <>
            {!secondParam ? <UploadSortBtn /> : null}
            {secondParam !== "add" ? <LoggerBtn /> : null}
            <Specified />
        </>
    );
};

export default CompaniesPage;
